var _style, _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,3C3.5,3,2.9,3.2,2.6,3.6S2,4.5,2,5v14c0,0.5,0.2,1.1,0.6,1.4S3.5,21,4,21h5v-2H4v-9h16v9h-5v2h5c0.5,0,1.1-0.2,1.4-0.6 S22,19.5,22,19V5c0-0.5-0.2-1.1-0.6-1.4S20.5,3,20,3H4z M5.5,5C6.3,5,7,5.7,7,6.5S6.3,8,5.5,8S4,7.3,4,6.5S4.7,5,5.5,5z M9.5,5 C10.3,5,11,5.7,11,6.5S10.3,8,9.5,8S8,7.3,8,6.5S8.7,5,9.5,5z M12,5h8v3h-8V5z M12,13l-3,4h2v5h2v-5h2L12,13z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 24,
    height: 24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/Open.82ac18183172993d6c00fe6f2521ed4c.svg";
export { ForwardRef as ReactComponent };